"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineerHandle = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
const DateDTO_1 = require("./DateDTO");
const EngineerWarningFlag_1 = require("./EngineerWarningFlag");
class EngineerHandle {
    constructor(engineer) {
        this.engineer = engineer;
        this.flags = undefined;
        this.emailSet = (0, memoizee_1.default)(() => new Set(this.emails || []));
        this.getSortedUtilization = (0, memoizee_1.default)(() => {
            const capacities = Array.from(this.utilization || []).filter((c) => !!c.team);
            return capacities.sort((a, b) => {
                if (a.year === b.year) {
                    if (a.month === b.month) {
                        return (a.day || 0) - (b.day || 0);
                    }
                    return (a.month || 0) - (b.month || 0);
                }
                return (a.year || 0) - (b.year || 0);
            });
        });
        this.getCapacities = (0, memoizee_1.default)((year, month) => {
            const offboardDate = this.getOffboardDate();
            const from = new Date(year, month, 1);
            const endOfMonth = new Date(year, month + 1, 1);
            const to = offboardDate
                ? new Date(Math.min(endOfMonth.getTime(), offboardDate.getTime()))
                : endOfMonth;
            if (to.getTime() < from.getTime()) {
                return [];
            }
            const filtered = this.getSortedUtilization().reduce((all, newUtilization) => {
                const lastTime = new Date(all[0]?.year || 0, all[0]?.month || 0, all[0]?.day || 1);
                const newTime = new Date(newUtilization.year || from.getFullYear(), newUtilization.month || from.getMonth(), newUtilization.day || 1);
                if (newTime.getTime() >= to.getTime()) {
                }
                else if (newTime.getTime() > lastTime.getTime() &&
                    newTime.getTime() <= from.getTime() &&
                    all.length > 0) {
                    all = [newUtilization];
                }
                else {
                    all.push(newUtilization);
                }
                return all;
            }, []);
            if (offboardDate && offboardDate.getTime() < endOfMonth.getTime()) {
                filtered.push({
                    year: offboardDate.getFullYear(),
                    month: offboardDate.getMonth(),
                    day: offboardDate.getDate(),
                    team: "",
                    percent: 0,
                });
            }
            return filtered;
        }, { max: 12 });
        this.getTeamIds = (0, memoizee_1.default)((year, month) => {
            return this.getCapacities(year, month).map((u) => u.team);
        }, {
            max: 12
        });
        Object.assign(this, engineer);
    }
    getOnboardDate() {
        const capacities = this.utilization || [];
        const capacity = capacities.length > 0 ? capacities[0] : undefined;
        return new Date(capacity?.year || 0, capacity?.month || 0, capacity?.day || 1);
    }
    getOffboardDate() {
        return this.offboardDate &&
            !isNaN(this.offboardDate.year) &&
            !isNaN(this.offboardDate.month) &&
            !isNaN(this.offboardDate.day)
            ? new Date(this.offboardDate.year, this.offboardDate.month, this.offboardDate.day)
            : undefined;
    }
    getMicrosftShiftsTimeOff(year, month) {
        const yearMonth = `${year}-${month}`;
        const microsoftShiftsTimeOff = this.microsoftShiftsTimeOff || {};
        const days = microsoftShiftsTimeOff[yearMonth] || [];
        return { year, month, days: days.length };
    }
    getDaysOff(year, month) {
        return (((this.engineer.timeOff || []).find((pto) => pto.year === year && pto.month === month)?.days || 0) + this.getMicrosftShiftsTimeOff(year, month).days);
    }
    isInTeam(teamId, year, month) {
        return !!this.getTeamIds(year, month).find((uTeamId) => uTeamId === teamId);
    }
    wasEverInTeam(teamId) {
        const capacity = this.utilization || [];
        return capacity.findIndex((c) => c.team === teamId) >= 0;
    }
    getWarningFlags() {
        if (!this.flags) {
            this.flags = new Set();
            if (!this.region) {
                this.flags.add(EngineerWarningFlag_1.EngineerWarningFlag.REGION_IS_UNDEFINED);
            }
            if (this.utilization.find((u) => !u.team)) {
                this.flags.add(EngineerWarningFlag_1.EngineerWarningFlag.TEAM_IS_UNDEFINED);
            }
            if (!this.harvestId) {
                this.flags.add(EngineerWarningFlag_1.EngineerWarningFlag.HARVERST_ID_UNDEFINED);
            }
        }
        return this.flags;
    }
    isOffboarded(now = new Date()) {
        const offboarding = this.getOffboardDate();
        return !!offboarding && offboarding.getTime() <= now.getTime();
    }
    compare(other) {
        const i1Name = `${this.firstName} ${this.lastName}`;
        const i2Name = `${other.firstName} ${other.lastName}`;
        return i1Name.toLowerCase().localeCompare(i2Name.toLowerCase());
    }
    getEmails() {
        return this.emailSet();
    }
    getDisplayName() {
        return (this.firstName || "") + " " + (this.lastName || "");
    }
    hasHarvestHours(year, month) {
        const key = (0, DateDTO_1.serializeMonthDTO)(year, month);
        return !!this.harvestHours[key];
    }
    getHarvestHours(year, month) {
        const key = (0, DateDTO_1.serializeMonthDTO)(year, month);
        const map = this.harvestHours || {};
        return map[key] || { total: 0, billable: 0, budgeted: 0 };
    }
    getRackspaceEmail() {
        return (this.emails || []).find((email) => email.indexOf("rackspace") > -1);
    }
    hasRackspaceEmail() {
        const email = this.getRackspaceEmail();
        return !!email;
    }
}
exports.EngineerHandle = EngineerHandle;
//# sourceMappingURL=EngineerHandle.js.map